import { AutogenLayoutOtherChargesQuickInfo } from "./autogen/AutogenLayoutOtherChargesQuickInfo";

export class OtherChargesQuickInfo extends AutogenLayoutOtherChargesQuickInfo {
}
